// Sets the matchday of the current season in the matchday picker and matchday area.

import { MatchdayPickEvent } from "@gaming/srvg-classes-core";

// ---------------------------------------------------------------------------------------------------------------------
export const setSelectedMatchday = ( matchday_nr: number ) => {
    if( matchday_nr >= 1 && matchday_nr <= srvg.config.matchdays_per_season ) {
        const matchday = app.view.matchdayArea.matchdayAreaModel.currentMatchday.getSeason().getMatchday( matchday_nr );
        if( matchday ) {
            app.customerIntegration.triggerEvent( new MatchdayPickEvent( matchday ) );
        }
    }
    // Ugly hack for matchday 31+
    else if( matchday_nr > srvg.config.matchdays_per_season ) {
        const nextSeason = app.view.matchdayArea.matchdayAreaModel.currentMatchday.getSeason().nextSeason();
        if( nextSeason ) {
            const matchday_nr_next_Season = matchday_nr % srvg.config.matchdays_per_season;
            const matchday = nextSeason.getMatchday( matchday_nr_next_Season );
            if( matchday ) {
                const index = app.view.matchdayArea.matchdayPicker.range.findIndex( matchday );
                if( index !== null ) {
                    app.customerIntegration.triggerEvent( new MatchdayPickEvent( matchday ) );
                }
            }
        }
    }
}